/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_BcInputs */

const en_node_bc = /** @type {(inputs: Node_BcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central`)
};

/**
* | output |
* | --- |
* | "Business Central" |
*
* @param {Node_BcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_bc = /** @type {((inputs?: Node_BcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_BcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_bc(inputs)
});